module.exports = __webpack_public_path__ + "static/uiuxdesign-83454d2cac062fd6e23c325fd6711c1d.png";